import axios, { BASE_URL } from "../axios";
import BaseModel from "./baseModel";

export default class ClientTechnicianModel extends BaseModel {
  static endPoint = "link/";

  static linkTech(identifier) {
    return axios.post(BASE_URL + this.endPoint + identifier);
  }
}
